import { render } from "./Graph.vue?vue&type=template&id=1bfadc88&scoped=true"
import script from "./Graph.vue?vue&type=script&lang=js"
export * from "./Graph.vue?vue&type=script&lang=js"

import "./Graph.vue?vue&type=style&index=0&id=1bfadc88&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bfadc88"]])

export default __exports__